// @ts-nocheck
import GridContainer from "@insite/mobius/GridContainer";
import GridItem from "@insite/mobius/GridItem";
import TextArea, { TextAreaProps } from "@insite/mobius/TextArea";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import { StyleguideSection } from "@store/Library/Components/Toolkit/Styleguide/ui";
import { getGridPreset } from "@toolkit/Framework/Common/Utilities/gridPreset";
import upperFirst from "lodash/upperFirst";
import React, { FC, useState } from "react";
import { useTheme } from "styled-components";

const errorText = "This field is invalid.";

const Row: FC<TextAreaProps> = ({ label, ...props }) => (
    <>
        <GridItem width={4}>
            <TextArea label={label} {...props} />
        </GridItem>
        <GridItem width={4}>
            <TextArea label={`${label} (Disabled)`} disabled {...props} />
        </GridItem>
        <GridItem width={4}>
            <TextArea label={`${label} (Error)`} required error={errorText} {...props} />
        </GridItem>
    </>
);

const Variant: FC<TextAreaProps> = ({ sizeVariant }) => {
    const theme = useTheme();
    const gridContainerProps = getGridPreset(theme.design.form.grid.base);
    const [sectionId] = useState(`subsection-${uniqueId()}`);

    return (
        <StyleguideSection variant="h3" title={upperFirst(sizeVariant)} sectionId={sectionId} isSubSection>
            <GridContainer {...gridContainerProps}>
                <Row label="Base" sizeVariant={sizeVariant} />
                <Row label="Placeholder" sizeVariant={sizeVariant} placeholder="Enter some text here" />
            </GridContainer>
        </StyleguideSection>
    );
};

const StyleguideTextAreas: FC = () => {
    const [sectionId] = useState(`section-${uniqueId()}`);

    return (
        <StyleguideSection title="Text Areas" sectionId={sectionId}>
            <Variant sizeVariant="default" />
            <Variant sizeVariant="small" />
            <Variant sizeVariant={"xsmall" as any} />
        </StyleguideSection>
    );
};

export default StyleguideTextAreas;
